<template>
  <div class="mainDiv">
    <el-row>
      <el-form ref="queryCondition" :model="queryCondition" label-position="right" label-width="100px">
        <el-col :span="10">
          <el-form-item label="部门名称">
            <el-input size="mini" v-model="queryCondition.departmentName" clearable placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" size="mini" @click="query()" icon="el-icon-search">查询</el-button>
            <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <el-row class="mb">
      <el-table :data="tableData" row-key="id" size="mini"  default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}" header-row-class-name="tableHeader">
        <el-table-column prop="label" label="名称"  width="500"></el-table-column>
        <el-table-column prop="level" label="级别" ></el-table-column>
        <el-table-column prop="sort" label="顺序" ></el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-tooltip content="增加子部门" placement="top" effect="light">
              <el-button @click="append(scope.row)" icon="el-icon-plus" size="small"></el-button>
            </el-tooltip>
            <el-tooltip content="编辑" placement="top" effect="light">
              <el-button @click="edit(scope.row)" icon="el-icon-edit" size="small"></el-button>
            </el-tooltip>
            <el-tooltip content="删除" placement="top" effect="light">
              <el-button type="danger" plain @click="remove(scope.row)" icon="el-icon-delete" size="small"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog title="部门管理" :visible="visible" :fullscreen="false" @close="closeDialog" width="30%"
               :close-on-click-modal="false">
      <el-form :model="deptForm" status-icon :rules="rules" ref="deptForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="deptForm.name" :maxlength="25" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="部门排序" prop="sort">
          <el-input v-model.number="deptForm.sort" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: "departmentList",
    components: {},
    created: function () {
      this.query();
      this.getDetpTree();
    },
    data() {
      const isNum  = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入排序号'));
        } else {
          const age= /^[0-9]*$/
          if (!age.test(value)) {
            callback(new Error('请填写数字'))
          }else{
            callback()
          }}
      };
      return {
        msg: "this is department",
        tableData: [],
        queryCondition: {
          departmentName: ""
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 100,
          number: 1
        },
        deptData: [],
        visible: false,
        deptForm: {
          id: 0,
          parentId: 1,
          name: "",
          level: 2,
          sort: ""
        },
        rules: {
          sort: [
            {
              validator: isNum,
              required: true,
              trigger: "blur"
            }
          ],
          name: [
            {
              required: true,
              message: "请填写部门名称",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                this.$axios
                  .get(
                    "/department/existdepartmentName?departmentName=" +
                    value +
                    "&parentId=" +
                    this.deptForm.parentId +
                    "&id=" +
                    this.deptForm.id
                  )
                  .then(response => {
                    if (
                      response.data !== null &&
                      response.data !== "" &&
                      response.data !== undefined
                    ) {
                      var nameList = response.data;
                      if (nameList.length > 0) {
                        return callback(new Error("部门已存在,请重新填写"));
                      }
                    }
                    return callback();
                  });
              },
              trigger: "blur"
            }
          ]
        }
      };
    },
    methods: {
      save: function () {
        this.$refs["deptForm"].validate(valid => {
          if (valid) {
            var _self = this;
            this.$axios.post("/department/save", this.deptForm).then(response => {
              _self.$message({
                message: "保存成功",
                type: "success"
              });
              _self.$refs["deptForm"].resetFields();
              _self.getDetpTree();
              this.visible = false;
            });
          }
        });
      },
      closeDialog: function () {
        this.visible = false;
        this.deptForm = {
          id: 0,
          parentId: 1,
          name: "",
          level: 2,
          sort: ""
        };
        this.$refs["deptForm"].resetFields();
      },
      append(data) {
        this.deptForm.parentId = data.id;
        this.deptForm.level = data.level + 1;
        this.visible = true;
      },
      edit(data) {
        this.deptForm.name = data.label;
        this.deptForm.sort = data.sort;
        this.deptForm.id = data.id;
        this.deptForm.parentId = data.parentid;
        this.deptForm.level = data.level;
        this.visible = true;
      },
      remove(data) {
        // if (node.childNodes.length > 0) {
        //   this.$message({
        //     message: "请先删除子部门",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (data.parentid == 0) {
          this.$message({
            message: "根节点不允许删除",
            type: "warning"
          });
          return false;
        }
        this.$confirm("是否删除此部门?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          var _self = this;
          this.$axios.get("/department/delete?id=" + data.id).then(res => {
            if (res.code == "0000") {
              _self.$message({
                type: "success",
                message: res.message
              });
              _self.getDetpTree();
            } else {
              _self.$message({
                type: "warning",
                message: res.message
              });
            }
          });
        });
      },

      getDetpTree: function () {
        let that = this;
        this.$axios.get("/department/departmentTree").then(response => {
          if (
            response.data !== null &&
            response.data !== "" &&
            response.data !== undefined
          ) {
            that.tableData = JSON.parse(response.data);
          }
        });
      },
      // 查询按钮
      query: function () {
        var url = "/department/departmentPage";
        if (this.queryCondition.departmentName == "") {
          this.getDetpTree();
          return;
        }
        url += "?departmentName=" + this.queryCondition.departmentName;
        url +=
          "&pageNumber=" +
          this.pagedata.number +
          "&pageSize=" +
          this.pagedata.size;
        let that = this;
        this.$axios.get(url).then(response => {
          if (
            response.data !== null &&
            response.data !== "" &&
            response.data !== undefined
          ) {
            that.tableData = response.data.content;
          }
        });
      },
      reset: function () {
        this.queryCondition.departmentName = '';
        this.$refs.queryCondition.resetFields();
        this.query();
      }
    }
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/department/list.vue